"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "HostMapInterceptor", {
  enumerable: true,
  get: function get() {
    return _hostmap.default;
  }
});
_Object$defineProperty(exports, "ServerErrorInterceptor", {
  enumerable: true,
  get: function get() {
    return _serverError.default;
  }
});
_Object$defineProperty(exports, "ServiceCatalog", {
  enumerable: true,
  get: function get() {
    return _serviceCatalog.default;
  }
});
_Object$defineProperty(exports, "ServiceHost", {
  enumerable: true,
  get: function get() {
    return _serviceHost.default;
  }
});
_Object$defineProperty(exports, "ServiceInterceptor", {
  enumerable: true,
  get: function get() {
    return _service.default;
  }
});
_Object$defineProperty(exports, "ServiceRegistry", {
  enumerable: true,
  get: function get() {
    return _serviceRegistry.default;
  }
});
_Object$defineProperty(exports, "ServiceState", {
  enumerable: true,
  get: function get() {
    return _serviceState.default;
  }
});
_Object$defineProperty(exports, "ServiceUrl", {
  enumerable: true,
  get: function get() {
    return _serviceUrl.default;
  }
});
_Object$defineProperty(exports, "Services", {
  enumerable: true,
  get: function get() {
    return _services.default;
  }
});
exports.constants = void 0;
var _webexCore = require("../../webex-core");
var constants = _interopRequireWildcard(require("./constants"));
exports.constants = constants;
var _services = _interopRequireDefault(require("./services"));
var _serverError = _interopRequireDefault(require("./interceptors/server-error"));
var _service = _interopRequireDefault(require("./interceptors/service"));
var _hostmap = _interopRequireDefault(require("./interceptors/hostmap"));
var _serviceCatalog = _interopRequireDefault(require("./service-catalog"));
var _serviceRegistry = _interopRequireDefault(require("./service-registry"));
var _serviceState = _interopRequireDefault(require("./service-state"));
var _serviceHost = _interopRequireDefault(require("./service-host"));
var _serviceUrl = _interopRequireDefault(require("./service-url"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('services', _services.default, {
  interceptors: {
    ServiceInterceptor: _service.default.create,
    ServerErrorInterceptor: _serverError.default.create
  }
});
//# sourceMappingURL=index.js.map
